<template>
  <div class="container">
    <!-- <p>algo</p> -->
    <!-- <p>query <pre>{{ query }}</pre></p> -->
    <p v-if="debug">
      <!-- Result:<br> -->
      Domain: {{ subDomain }} <br>
      Path: {{ linker }} <br>
      query: {{ query }} <br>
      location: {{ location }} <br>
      params: {{ params }}
    </p>
    <div class="row" style="text-align: center" >
      <div class="col">
        <img src="@/assets/logo_obra_digital.jpg" style="width: 140px;" />
      </div>
    </div>
    <div style="text-transform: uppercase; color: #2B3775; font-weight: 800; margin-top: 40px;">Bienvenidos a Obra Digital</div>
    <br>
    <div class="row" style="text-align: center" v-if="rp === true">
      <div class="col">Para acceder a este link <br />por favor ingresar la clave: <br /></div>
    </div>
    <div class="row" v-if="rp === true">
      <div class="col-xl-2 offset-xl-5">
        <input ref="password" type="password" v-model="password" class="form-control">
      </div>
      <div class="col-xl-1">
        <!-- <div @click.prevent="showPasswordToggle" style="text-transform: uppercase; color: #2B3775; font-weight: 800; font-size: 12px;margin-top:8px;">ver clave</div> -->
        <a href="#" @click.prevent="showPasswordToggle" style="text-transform: uppercase; color: #2B3775; font-weight: 800; font-size: 12px;margin-top:8px;">ver clave</a>
      </div>

<!--         <div class="col-auto">
          <span id="passwordHelpInline" class="form-text">
      Must be 8-20 characters long.
    </span>
        </div> -->

      
    </div>

    <div v-if="notFound === true" class="row">
      <div class="col-xl-2 offset-xl-5" style="margin-top: 20px;">
        <div style="text-transform: uppercase; color: red; font-weight: 800;">Datos incorrectos<br><a href="https://www.obradigital.cl/">ir a obradigital.cl</a></div>
      </div>
    </div>

    <div class="row" style="margin-top: 10px;" v-if="rp === true">
      <div class="col-xl-2 offset-xl-5">
        <button class="form-control btn btn-secondary" @click.prevent.stop="getLink2">entrar</button>
      </div>
      <div class="col-xl-1">
        <!-- texto -->
      </div>
      
    </div>
    <div v-if="notFound === false" style="margin-top: 20px;">cargando información...</div>
    <!-- <div v-if="notFound === true">Link no encontrado... <br><a href="https://www.obradigital.cl/">ir a obradigital.cl</a></div> -->
    <!-- <p>params: <pre>{{ params }}</pre></p> -->
    <!-- <p>location <pre>{{ location }}</pre></p> -->
    <!-- <p>hostname: <pre>{{ hostname }}</pre></p> -->
    <!-- <p>subDomain: <pre>{{ subDomain }}</pre></p> -->
  </div>
</template>
<script>
import axios from 'axios'
const linksApiUrl = process.env.VUE_APP_LINKS_API
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      // route: {},
      query: {},
      location: {},
      params: {},
      hostname: '',
      linker: '',
      notFound: null,
      debug: false,
      rp: false,
      password: ''
      // subDomain: ''
    }
  },
  mounted: function () {
    try {
      // this.route = this.$route.params.pathMatch
      // console.log(this.$route)
      console.log(this.$route)
      console.log(window.location)
      // console.log(window.location.pathname)
      this.query = this.$route.query
      this.params = this.$route.params
      this.linker = this.params.linker
      this.debug = this.$route.query.debug

      const { location, host, hash, hostname, href, origin, pathname, port, search } = window.location
      this.location = { location, host, hash, hostname, href, origin, pathname, port, search }
      this.hostname = hostname

      this.getLink()
      // this.fileCase = this.$route.query.fileCase
    } catch (e) {
      //
      console.log('fail 1')
    }
  },
  computed: {
    // a computed getter
    subDomain: function () {
      // `this` points to the vm instance
      if (process.env.NODE_ENV === 'beta') {
        return 'beta'
      } else {
        let out = ''
        let domain = '.obradigital.cl'
        if (this.hostname && this.hostname.indexOf(domain) !== -1) {
          out = this.hostname.split(domain)[0]
        } else if (this.hostname === 'localhost') {
          out = 'fotos'
        }
        return out
        // return this.message.split('').reverse().join('')
      }

    }
  },
  methods: {
    showPasswordToggle: function () {
      // if (this.$refs['password'].type === 'text') {
      //   this.$refs['password'].type = 'password'
      // } else {
      //   this.$refs['password'].type = 'text'
      // }
      const self = this
      this.$refs['password'].type = 'text'
      setTimeout(() => {
        self.$refs['password'].type = 'password'
      }, 1000 * 5)
      // console.log(this.$refs['password'].type = 'text')
    },
    getLink: function () {
      // al final hacer redirect

      const { linker, subDomain } = this
      const text = linker
      const params = { text, subDomain }
      axios
        .get(linksApiUrl, { params })
        .then(response => {
          // this.loading = false
          console.log('>> recibo', response.data)
          if (response && response.data && response.data.data && response.data.data.length && response.data.data[0]) {
            const { url, rp } = response.data.data[0]
            if (rp === true) {
              // requiere clave, segundo llamado
              this.rp = true
            } else {
              // ahora redirect
              this.notFound = false
              this.redirect(url)
            }

          } else {
            this.notFound = true
            // redirect to not found
            // this.$router.push({ name: 'notFound' });
          }
        })
    },
    getLink2: function () {
      const { linker, subDomain, password } = this
      // console.log('>>> pass', this.password)
      const text = linker
      const params = { text, subDomain, password }
      axios
        .post(linksApiUrl, params)
        .then(response => {
          console.log('>> recibo', response.data)
          try {
            const { url } = response.data.data[0]
            if (url && url.length > 5) {
              // ahora redirect
              this.notFound = false
              // alert('>>> about to redirect to' + url)
              this.redirect(url)
            } else {
              this.notFound = true
              this.$router.push({ name: 'notFound' });
            }
          } catch (e) {
            this.notFound = true
            // this.$router.push({ name: 'notFound' });
          }
        })
    },
    redirect: function (url = '') {
      // https://stackoverflow.com/a/39791307/2027670
      // window.location.replace(url)
      // window.location.replace(url)
      console.log('>>> redirect a ', url)
      if (this.debug) {
        // nothing
      } else {
        window.location.replace(url)
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>